import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NoPageFoundComponent } from './components/no-page-found/no-page-found.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/base/base.module').then(mod => mod.BaseModule),
    pathMatch: 'full',
  },
  {
    path: 'voiture-sans-permis',
    loadChildren: () => import('./modules/voiture-sans-permis/voiture-sans-permis.module').then(mod => mod.VoitureSansPermisModule),
  },
  {
    path: 'carte-grise',
    loadChildren: () => import('./modules/carte-grise/carte-grise.module').then(mod => mod.CarteGriseModule),
  },
  {
    path: 'nettoyage-moteur',
    loadChildren: () => import('./modules/nettoyage-moteur/nettoyage-moteur.module').then(mod => mod.NettoyageMoteurModule),
  },
  {
    path: 'entretien',
    loadChildren: () => import('./modules/entretien/entretien.module').then(mod => mod.EntretienModule),
  },
  {
    path: 'administration',
    loadChildren: () => import('./modules/administration/administration.module').then(mod => mod.AdministrationModule),
  },
  {
    path: 'contact',
    loadChildren: () => import('./modules/contact/contact.module').then(mod => mod.ContactModule),
  },
  {
    path: 'inventaire',
    loadChildren: () => import('./modules/inventaire/inventaire.module').then(mod => mod.InventaireModule),
  },
  {
    path: 'mecanique',
    loadChildren: () => import('./modules/mecanique/mecanique.module').then(mod => mod.MecaniqueModule),
  },
  {
    path: 'social',
    loadChildren: () => import('./modules/social/social.module').then(mod => mod.SocialModule),
  },
  {
    path: 'catalogue',
    loadChildren: () => import('./modules/catalogue/catalogue.module').then(mod => mod.CatalogueModule),
  },
  // { path: '', redirectTo: 'accueil', pathMatch: 'full' },
  // { path: 'login', redirectTo: 'accueil/login' },
  { path: '**', redirectTo: '', pathMatch: 'full' }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
